<template>
</template>

<script>
export default {
    data: function () {
        return {
            showSearch: false,
            filters: {
                free_search: '',
                sort_by: 'created_at',
                order: 'desc',
            },
            pagination: {},
            transactions: [],
            sort: {
                product_type: 'asc',
                created_at: 'desc',
                quantity: 'asc',
                voucher_price: 'asc',
            },
            page: typeof this.request.page != 'undefined'
                            ? parseInt(this.request.page)
                            : 1,
        }
    },
    props: [
        'url',
        'request',
    ],
    computed: {
    },
    created() {
        this.getResults();
    },
    mounted() {
    },
    watch: {
        filters: {
            handler() {
                this.filterResults();
            },
            deep: true,
        },
    },

    methods: {
        toggleSort(key) {
            let currentOrder = this.sort[key];
            let newOrder = currentOrder == 'asc' ? 'desc' : 'asc';

            this.sort[key] = newOrder;

            this.filters.sort_by = key;
            this.filters.order = newOrder;
        },
        setPagination(page) {
            if (typeof this.$refs.paginator != 'undefined') {
                this.$refs.paginator.selected = page - 1;
            };
        },

        /**
         * To avoid issues where refreshless filtering has fewer results
         * than the currently selected page, we reset the page number any
         * time someone runs the filters
         *
         * Additionally, we reset the paginator to the 1st page
         * https://github.com/lokyoung/vuejs-paginate/issues/16
         *
         * @return {void}
         */
        filterResults: _.debounce(function() {
            this.changePage(1);
            this.getResults();
        }, 500),

        getResults() {
            let params = this.filters;
            params.page = this.page;

            axios
                .post(this.url, params)
                .then(response => {
                    this.transactions = response.data.data;
                    this.pagination = response.data.meta.pagination;

                })
                .catch(error => {
                    console.log(error.response);
                });
            this.setPagination(this.page);
        },
        /**
         * Callback function for the vuejs-paginate component
         *
         * @param  {integer} page
         *
         * @return {void}
         */
        changePage (page) {
            this.page = page;
            this.getResults();
        },
    },
    components: {
    }
}
</script>
